/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {forwardRef} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useFormikContext} from 'formik';
import {Button} from 'react-bootstrap';

const messages = defineMessages({
  confirm: {id: 'button.confirm'},
});

const ConfirmButton = (
  {message = messages.confirm, variant = 'primary', disabled = false, ...props},
  ref
) => {
  const {isSubmitting} = useFormikContext();

  return (
    <Button
      ref={ref}
      variant={variant}
      disabled={isSubmitting || disabled}
      {...props}
    >
      <FormattedMessage {...message} />
    </Button>
  );
};
ConfirmButton.displayName = 'ConfirmButton';

export default forwardRef(ConfirmButton);
